import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ApiService from '../services/api.service';

export default function SystemSession() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const initializeWithJwt = async () => {
      const code = searchParams.get('code');
      const results = await ApiService.getInstance().request('POST', `/system/login/exchange`, { code }) as any;
      sessionStorage.setItem('plb_auth_state', JSON.stringify(results.record));
      navigate('/');
    };

    initializeWithJwt();
  }, []);

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-muted-foreground">Loading...</div>
    </div>
  );
}
